export interface RangeOption<T extends string> {
  value: T;
  label: string;
}

interface RangeSelectorProps<T extends string> {
  options: RangeOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  itemClassName?: string;
  ariaLabel?: string;
}

function RangeSelector<T extends string>({
  options, value, onChange, className = '', itemClassName = '', ariaLabel,
}: RangeSelectorProps<T>) {
  return (
    // min-w-0 is load-bearing: without it this flex item won't shrink and
    // overflow-x-auto never engages.
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={`segmented min-w-0 max-w-full overflow-x-auto scrollbar-hide ${className}`}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          role="tab"
          aria-selected={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={`segmented-item whitespace-nowrap ${itemClassName} ${value === opt.value ? 'segmented-item-active' : ''}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default RangeSelector;
